/** @format */

import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import Lottie from "lottie-react";
import animationData from "../../../../assets/animations/tqPanelLoader.json";
import QuoteFormWrapper from "../../../../shared/components/quoteFormWrapper";
import useAppStateStore from "../../../../shared/store/AppStateStore";
import { goBackToLastStep } from "../../../../shared/utils/navigationUtils";
import QuoteStep from "../../enums/QuoteStep";
import TqPanelCoverageCard from "./TqPanelCoverageCard";
import QuoteStepHeading from "../../../../shared/components/QuoteStepHeading";

const TqPanelLoader = () => {
  const STATE = useAppStateStore();
  const action = STATE.actionOnTqPanel;
  const lottieRef = useRef(null);
  const [reduceMotion, setReduceMotion] = useState(false);

  let message = "Retrieving quotes...";
  if (action === "UpdateQuoteResults") {
    message = "Updating quotes...";
  } else if (action === "quoteSelected") {
    message = "Selecting your quote...";
  }

  // We track the step from which the user come to the loader from, if the screen is in fact the loader itself, we send them back
  useLayoutEffect(() => {
    if (
      STATE.previousStep &&
      STATE.previousStep === QuoteStep.TQ_PANEL_LOADER
    ) {
      goBackToLastStep();
    } else {
      STATE.setPreviousStep(QuoteStep.TQ_PANEL_LOADER);
    }
  }, []);

  useEffect(() => {
    if (!window.matchMedia) return undefined;
    const motionQuery = window.matchMedia("(prefers-reduced-motion: reduce)");
    const updateMotionPreference = () => setReduceMotion(motionQuery.matches);

    updateMotionPreference();
    if (motionQuery.addEventListener) {
      motionQuery.addEventListener("change", updateMotionPreference);
      return () =>
        motionQuery.removeEventListener("change", updateMotionPreference);
    }

    motionQuery.addListener(updateMotionPreference);
    return () => motionQuery.removeListener(updateMotionPreference);
  }, []);

  useEffect(() => {
    if (reduceMotion && lottieRef.current) {
      lottieRef.current.goToAndStop(0, true);
    }
  }, [reduceMotion]);

  return (
    <QuoteFormWrapper>
      <QuoteStepHeading
        title={message}
        description="Sit tight, we’re collecting the best insurance options for your taxi."
        className="tw-mb-6"
      />
      <TqPanelCoverageCard />
      <Lottie
        lottieRef={lottieRef}
        animationData={animationData}
        loop={!reduceMotion}
        autoplay={!reduceMotion}
        className="tw-block tw-w-full"
        rendererSettings={{
          preserveAspectRatio: "xMidYMid slice",
        }}
      />
    </QuoteFormWrapper>
  );
};

export default TqPanelLoader;
